<!--页面代码从这里开始拷贝-->
<template>
  <div>
    <table-compnent
      :records="tableData"
      @resetHandler="reset"
      @searchHandler="doSearch"
      @queryByIdHandler="queryById"
      @deleteByIdHandler="deleteById"
      @batchDeleteHandler="batchDelete"
      @addHandler="saveSmsLog"
    >
      <template v-slot:search>
        <el-form-item label="手机号:">
          <el-input
            v-model="search.mobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="发送时间:">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              v-model="dateBetween"
              type="datetimerange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              default-time="['12:00:00', '08:00:00']"
            >
            </el-date-picker>
          </div>
        </el-form-item> -->
      </template>
      <template v-slot:content>
        <el-table-column prop="env" label="环境"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="status" label="发送状态"></el-table-column>
        <el-table-column prop="applicationName" label="应用名称"></el-table-column>
        <el-table-column prop="createTime" label="发生时间"></el-table-column>
      </template>
    </table-compnent>
  </div>
</template>

<script>
import TableCompnent from "@/components/table/TablesComponents";
import SmsLogApi from "@/api/SmsLogApi";
import { navTo, queryParam } from "@/utils/NavigatorUtils";
export default {
  name: "SmsLogList",
  props: {
    msg: String,
  },
  components: {
    TableCompnent,
  },
  data() {
    return {
      tableData: {},
      search: {
        mobile: "",
      },
      page: {},
      dateBetween: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近1分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 60 * 1000 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近3分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 60 * 1000 * 3);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近5分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 60 * 1000 * 5);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近10分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 60 * 1000 * 10);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近30分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 60 * 1000 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近1小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 1);
              picker.$emit("pick", [start, end]);
            },
          },

          {
            text: "最近2小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 2);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近3小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 3);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted(){
    let date = new Date();
    let defalutStartTime = date.getTime() - 5 * 60 * 1000; // 转化为时间戳
    let startDateNs = new Date(defalutStartTime);
    this.dateBetween = [startDateNs, date];
    this.search.startTime =startDateNs;
    this.search.endTime = date;
  },
  methods: {
    reset() {
      this.search = {};
    },
    doSearch(params) {
      this.page = params;
      this.search.pageSize = this.page.pageSize;
      this.search.pageNum = this.page.pageNum;
      SmsLogApi.search(this.search).then((resp) => {
        if (resp.state == "OK") {
          this.tableData = resp.data;
        }
      });
    },
    saveSmsLog() {
      navTo(this, "/saveSmsLog");
    },
    queryById(id) {
      SmsLogApi.querySmsLogById(id).then((resp) => {
        if (resp.state == "OK") {
          queryParam(this, "saveSmsLog", resp.data);
        }
      });
    },
    deleteById(id) {
      SmsLogApi.deleteSmsLog(id).then((resp) => {
        if (resp.state == "OK") {
          this.doSearch(this.page);
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
    batchDelete(params) {
      SmsLogApi.batchDeleteSmsLog(params).then((resp) => {
        if (resp.state == "OK") {
          this.$successMsg(resp.msg);
          this.doSearch(this.page);
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
  },
};
</script>
<!--页面代码从这里结束拷贝-->